export default __webpack_public_path__ + "static/media/bg2.4084d190.svg";